import {BackendApi} from "../../api/api.ts";

export async function initiateFinancialServiceConnection(
    api: BackendApi,
    institutionId: string,
): Promise<void> {
    const data = await api.Business__connectFinancialService(window.location.hostname, institutionId)
    window.location.replace(data.url)
}
